<template>
  <div class="basic-container" ref="basicCont">
    <div class="el-card" :style="{'height': containerHeight, 'width': containerWidth}">
      <el-scrollbar style="height: 100%;">
        <div style="padding: 10px;">
          <slot></slot>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import _ from 'lodash'
  import layout from '@/const/layout'

  export default {
    name: "basicContainer",
    data() {
      return {
        containerWidth: '0px',
        containerHeight: '0px',
        // [侧边栏宽度] 正常状态
        asideWidth: layout.asideWidth,
        // [侧边栏宽度] 折叠状态
        asideWidthCollapse: layout.asideWidthCollapse,
        // 头部高度
        headerHeight: layout.headerHeight,
      }
    },
    methods: {
      initContainer:_.debounce(function(){
        let containerWidth = document.documentElement.clientWidth;
        if(this.isCollapse){
          this.containerWidth = containerWidth - this.asideWidthCollapse - 20 + 'px';
        }else{
          this.containerWidth = containerWidth - this.asideWidth - 20 + 'px';
        }

        let containerHeight = document.documentElement.clientHeight;
        this.containerHeight = containerHeight - this.headerHeight - 20 - 4 + 'px';
      },200)
    },
    mounted() {

      this.initContainer();
      this.$nextTick(function () {
        window.addEventListener('resize', this.initContainer);
      })
    },
    computed:{
    ...mapGetters([ 'isCollapse'])
    },
    watch: {
      isCollapse: function (val) { //treecompanyId
        this.initContainer();
      }
    },
  };
</script>

<style lang="scss" scoped>
  .basic-container {
    height: 100%;
    border-radius: 6px;
    .el-card {
      margin: 0;
      height: auto !important;
      width: auto !important;
    }
  }

  .el-scrollbar__bar is-vertical {
    margin-right: -10px;
  }
</style>
